export default {
  'signup.name': 'Persona',
  'signup.insurance': 'Insurance',
  'signup.insurance-type': 'Insurance type',
  'signup.insurance-number': 'Personal Insurance Number',
  'signup.insurer-number': 'Health Insurer Number',
  'signup.contact': 'Contact',
  'signup.password': 'Password',

  'signup.required-field': 'This field must be set',
  'signup.prefix.mr': 'Mr.',
  'signup.prefix.ms': 'Mrs.',
  'signup.first-name': 'First name',
  'signup.last-name': 'Last name',
  'signup.sex': 'Sex',
  'signup.sex.none': 'Prefer not to say',
  'signup.title': 'Title',
  'signup.date-of-birth': 'Date of birth',
  'signup.sex.tooltip': 'We guarantee that no personal data will be shared',
  'signup.date-of-birth.tooltip': 'We guarantee that no personal data will be shared',
  'signup.summary': 'Summary',
  'signup.summary.description': 'Please check if the entered data is correct.',

  'signup.invalid-email': 'Please enter a valid e-mail address',
  'signup.invalid-phone': 'Invalid phone number',

  'signup.phone': 'Phone number',
  'signup.e-mail': 'Email',

  'signup.password.tooltip': 'Your password must contain more than {minCount} characters.',
  'signup.password-repetition': 'Password repetition',

  'password-validation.minLength': 'Password has at least {length} characters',
  'password-validation.number': 'Password contains a number',
  'password-validation.match': 'Passwords match',
  'password-validation.capital': 'Password contains capital letters',
  'password-validation.specialChar': 'Password contains a special character',

  'create-user': 'Create account',
  'create-user.success': 'Account was created successfully',
  'create-user.error': 'An error occurred while creating the account',
  'create-user.error.description':
    'Please check if you already have an account with the given email address.',
  'create-user.success.description': 'You can now log in with your access data',

  'captcha.solve': 'Please solve captcha',
  'captcha.error': 'Captcha could not be solved',

  'existing-user': 'An account with the provided contact details already exists',
  'existing-user.phone': 'Provided phone number is already linked to an account.',
  'existing-user.email': 'Provided email is already linked to an account.',
  'existing-user.email-phone': 'Provided email or phone number is already linked to an account.',
  'existing-user.to-login': 'To Login',
  'existing-user.change-phone': 'Change phone number',
  'existing-user.change-email': 'Change email',
  'existing-user.change-email-phone': 'Change email and phone number',

  'terms-and-conditions': 'T&C',
  privacy: 'Privacy policy',

  '2fa.error': 'Two-factor authentication failed',
  '2fa.error.description': 'Please check your input.',

  'password-mismatch': 'Please enter the same password twice',
  'change-password.error':
    'Password could not be changed. Please check the correctness of the old password.',

  'email-confirmation': 'Email confirmation',
  'email-confirmation.two-factor': 'Two-factor authentication',
  'email-confirmation.description':
    'You have been sent an email with a confirmation link. To sign up, please open the link in the email or enter the code from the email here.',

  'account-verification': 'Account verification',
  'account-verification.description':
    'We are pleased to welcome you to {tenant}. In order to fully use your account, verification of your email is required. To do so, click on the verification link sent to the email address you provided ({email}).',
  'account-verification.invalid-code': 'Invalid code - Please try again.',
  'account-verification.valid-until': 'Valid until',
  'account-verification.no-email': 'Didn’t receive an e-mail?',

  'email.resent': 'Email was sent again',
  'email.resent.description': 'Please check your email inbox for {email}',

  'error.login': 'Email or password incorrect. Please check your access data',

  'auth-required': 'Login required',
  'auth-required.description': 'You must be logged in to visit this page.',

  'back-to-booking': 'Back to booking',
  'back-to-destination': 'Back to the application',

  'confirmable-action.action-token-sent.email.title':
    'A confirmation link has been sent to your e-mail.',

  'confirmable-action.action-token-sent.email-partial.sub-title':
    'Please continue here after confirming the link.',
  'confirmable-action.action-token-sent.email-partial.done': 'I confirmed the link',

  'confirmable-action.action-token-sent.email-full.sub-title':
    "There's nothing left todo here. Please continue with the link.",
  'confirmable-action.action-token-sent.email-full.done': 'Okay',
  'confirmable-action.skip': 'Skip',

  'go-to-login': 'Go to log-in',
};
